
import { MapPin, Phone } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const ContactUs = () => {
  return (
    <section className="py-16 px-4 bg-background">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12">Contact Us</h2>
        <div className="grid grid-cols-1 gap-8">
          <Card className="fade-in">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <MapPin className="h-5 w-5" />
                Managed by Seaside Vacations
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-muted-foreground">
                3620 N Croatan Hwy<br />
                Kitty Hawk, NC 27949
              </p>
              <div className="space-y-2">
                <p className="text-muted-foreground flex items-center gap-2">
                  <Phone className="h-4 w-4" />
                  Local: <a href="tel:252-261-5500" className="text-primary hover:underline">252-261-5500</a>
                </p>
                <p className="text-muted-foreground flex items-center gap-2">
                  <Phone className="h-4 w-4" />
                  Toll-Free: <a href="tel:800-395-2525" className="text-primary hover:underline">800-395-2525</a>
                  {" "}or{" "}
                  <a href="tel:855-691-3591" className="text-primary hover:underline">855-691-3591</a>
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
